import React, { useState } from "react";
import { Box, Typography, Grid, Pagination } from "@mui/material";
import { DarkGrey, Primary, White01 } from "src/styles/color";
import font from "src/styles/font";
import { convertIntToCurrency } from "src/common";

const SalesCategoryChart = ({ data, selectedItemCode, onItemClick }) => {
  const [page, setPage] = useState(0);
  const itemsPerPage = 10;
  const startIndex = page * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = data.slice(startIndex, endIndex);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const maxValue = Math.max(...data.map((item) => item.value));
  const totalValue = data.reduce((acc, item) => acc + item.value, 0);
  const percent = (value) => ((value / totalValue) * 100).toFixed(2);

  const SalesBar = ({ active, item }) => (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      sx={{
        py: 1,
        px: 2,
        borderRadius: 4,
        color: DarkGrey,
        fontWeight: 500,
        "&:hover": {
          backgroundColor: White01,
          color: Primary,
          fontWeight: 600,
        },
        ...(active && {
          backgroundColor: White01,
          color: Primary,
          fontWeight: 600,
        }),
        transition: "background-color 0.3s ease",
        cursor: "pointer",
      }}
      onClick={() => {
        onItemClick(item.itemCode);
      }}
    >
      <Typography
        variant="body2"
        sx={{
          minWidth: {
            xs: 64,
            md: 130,
          },
          maxWidth: { xs: 64, md: 130 },
          textAlign: "left",
          color: "inherit",
          fontWeight: "inherit",
        }}
      >
        {item.itemCode}
      </Typography>
      <Box flex={1}>
        <Box
          sx={{
            width: "100%",
            height: 10,
          }}
        >
          <Box
            sx={{
              width: `${(100 * item.value) / maxValue}%`,
              height: "100%",
              backgroundColor: Primary,
              borderRadius: 20,
            }}
          />
        </Box>
      </Box>
      <Typography
        variant="body2"
        sx={{
          fontSize: {
            xs: `${font.size.xs} !important`,
            md: `${font.size.sm} !important`,
          },
          maxWidth: { xs: 64, md: 140 },
          textAlign: "left",
          color: "inherit",
          fontWeight: "inherit",
        }}
      >
        ฿ {convertIntToCurrency(item.value)} ({percent(item.value)}%)
      </Typography>
    </Box>
  );

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <Box bgcolor="#fff" borderRadius={4}>
      <Typography variant="h6" fontWeight={700}>
        ยอดขายรายสินค้า
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        กดเลือกรายการจะแสดงกราฟด้านล่าง
      </Typography>

      {data.length !== 0 ? (
        <>
          <Grid container spacing={1}>
            {paginatedData.map((item, idx) => (
              <Grid item xs={12} key={idx}>
                <SalesBar
                  active={item.itemCode === selectedItemCode}
                  item={item}
                />
              </Grid>
            ))}
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 2,
              paddingBottom: 2,
            }}
          >
            <Pagination
              count={totalPages}
              page={page + 1}
              onChange={(event, value) => {
                handlePageChange(value - 1);
              }}
            />
          </Box>
        </>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height={200}
        >
          <Typography variant="body2" color={DarkGrey}>
            ไม่มีข้อมูล
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default SalesCategoryChart;
